import { useNavigate } from "react-router-dom";
import ShebaFintechSuccessIcon from "../../../assets/icons/ShebaFintechSuccessIcon";
import ShebaFintechLayout from "../../../layouts/ShebaFintechLayout";

export default function ShebaFintechSuccess() {
  const navigate = useNavigate();
  return (
    <>
      <ShebaFintechLayout>
        <div className="flex items-center justify-center">
          <div className="rounded-full w-[120px] h-[120px] flex items-center justify-center">
            <ShebaFintechSuccessIcon />
          </div>
        </div>

        <div className="text-center justify-start text-white text-base font-medium font-['Inter']">
          Successfully Done!
        </div>

        <div
          onClick={() => navigate("/admin/dashboard")}
          className="text-center justify-start text-white text-base font-medium font-['Inter'] underline cursor-pointer"
        >
          Back to home
        </div>
      </ShebaFintechLayout>
    </>
  );
}
